/**
 * developer-step-disabler.ts
 * Copyright © 2016-2018, My Coverage Plan, Inc.
 * All rights reserved.
 */

/**
 * @author Taylor DH Smith <tdsmith@safetyweb.org>
 */

import { ClassProvider, Injectable } from "@angular/core";

import { UserService } from "../../../auth/identity/user.service";
import { AlgorithmStep, IntakeStep } from "../../structure/";
import { StepTransformer, TransformerEffects }
    from "./step-transformer";

// TODO: This class should be expanded to support a more general "role-required"
// hint that provides a parameter identifying the role needed. (In particular
// this would be nice for the support user role, but could have much use later.)

/**
 * The {@link DeveloperStepDisabler} stage of the {@link AlgorithmStep}
 * pipeline marks developer-only entries as editable or non-editable, depending
 * on the current user's roles.
 */
@Injectable()
export class DeveloperStepDisabler extends StepTransformer
{
    // Where this class should be sorted in the transformer list
    public order : number = 15;

    /**
     * Create the {@link DeveloperStepDisabler}
     */
    public constructor (
        protected user : UserService
    )
    {
        super();
    }

    public matchesType (type : any) : boolean
    {
        return type === IntakeStep;
    }

    /**
     * Disable developer steps for non-developer users
     */
    public create (step : IntakeStep) : TransformerEffects
    {
        if (step.hints.developer && !this.user.self.dev)
        {
            // user is not a developer, so disable the step
            step.hints.editable = false;
        }
        return {};
    }

    public apply () : TransformerEffects
    {
        return {};
    }
}

/**
 * Create a provider for easy import that uses the {@link StepTransformer} class
 * as a multi-provider injection token.
 */
export const DEVELOPER_STEP_DISABLER : ClassProvider = {
    provide: StepTransformer,
    useClass: DeveloperStepDisabler,
    multi: true
};



// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./app/algorithms/management/pipeline/developer-step-disabler.ts